/**
 * TermsPage.jsx — iter881
 *
 * Dedicated /terms URL for Google OAuth consent screen.
 * Renders only the Terms-relevant sections of LegalPage:
 *   • Intellectual Property
 *   • Terms of Service
 *   • Disclaimer + Data Controller
 */
import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function TermsPage() {
  return <LegalPage variant="terms-only" pathOverride="/terms" />;
}
